<template>
    <div>
        <input type="text"  autocomplete="off" class="layui-input" readonly="readonly"/>
        <i class="layui-icon layui-icon-date" style="position: absolute;top:8px;right: 8px;margin-top: 0px;"></i>
    </div>
</template>

<script>
// 该组件暂时不支持v-model,不建议用在form表单中，一般用于查询表单中
export default {
    name: 'LayuiDaterange',
     _model: {
        default: '',
        required: false
    },
    props: {
        placeholder: {
            default: '',
            type: String
        },
         _model: {
            default: '',
            required: false
        }
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data: function(){
        return {
        }
     },
     mounted(){
        var id = this.id = 'layuidaterange' + this.uuid();
        var element = this.el = $(this.$el);
        if(this.placeholder) {
            element.find('input').attr('placeholder', this.placeholder);
        }
        element.find('input').attr('id', this.id);
        this.layui.laydate.render({
            elem: '#' + this.id,
            type: 'date',
            range: true,
            trigger: 'click',//出现在input框失去焦点、时间选择框进而隐藏
            done: (value, date) => {
                this.$emit('_modelEvent', value);
                this.$emit('dateChange', value);
            }
        });
    },
    methods: {
        select(value) {
            $('#' + this.el.find('input').attr('id')).val(value);
        },
        reset() {
            $('#' + this.el.find('input').attr('id')).val('');
        }
    },
    watch:{
         _model(value){
           this.select(value);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiDaterange.vue